import { render, staticRenderFns } from "./chineseplus_live2023.vue?vue&type=template&id=a21d2344&scoped=true"
import script from "./chineseplus_live2023.vue?vue&type=script&lang=js"
export * from "./chineseplus_live2023.vue?vue&type=script&lang=js"
import style0 from "./chineseplus_live2023.vue?vue&type=style&index=0&id=a21d2344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21d2344",
  null
  
)

export default component.exports